
import React from 'react';
import { Filter, Check, X } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Button } from '@/components/ui/button';
import { ProductLinkFilter } from '../types';

interface FilterBarProps {
  filterValue: ProductLinkFilter;
  setFilterValue: (value: ProductLinkFilter) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ filterValue, setFilterValue }) => {
  return (
    <div className="p-6 pb-4 w-full bg-white dark:bg-[#1a1d2d] border-b dark:border-gray-700/50">
      <div className="flex items-center space-x-2 mb-4">
        <Filter className="h-5 w-5 text-gray-500 dark:text-gray-400" />
        <h3 className="text-sm font-medium dark:text-gray-200">Filtrer les vidéos:</h3>
        
        <RadioGroup 
          className="flex space-x-4" 
          defaultValue="all" 
          value={filterValue}
          onValueChange={(value) => setFilterValue(value as ProductLinkFilter)}
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="all" id="all" />
            <Label htmlFor="all" className="dark:text-gray-300">Toutes</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="linked" id="linked" />
            <Label htmlFor="linked" className="flex items-center dark:text-gray-300">
              <Check className="h-4 w-4 mr-1 text-green-500" /> 
              Liées à un produit
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="unlinked" id="unlinked" />
            <Label htmlFor="unlinked" className="flex items-center dark:text-gray-300">
              <X className="h-4 w-4 mr-1 text-red-500" /> 
              Non liées
            </Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default FilterBar;
